<template>
  <div class="row search-filter-category">
    <div class="col-12">
      <a v-b-toggle="`collapse-event-filter-facet`" class="facet-collapse-icon c-pointer">
        <font-awesome-icon
          class="when-opened "
          icon='caret-down'
          size="lg" />
        <font-awesome-icon
          class="when-closed fa-w-10"
          icon='caret-right'
          size="lg" />
      </a>
      <span class="font-weight-bold ">Event Filters</span>
      <b-collapse :id="`collapse-event-filter-facet`"
        class="row"
        :visible="initialSearchCategoryStates['event']">
        <div class="search-filter-list">
          <span class="sub-search-type-filter search-panel-items">Has Event Type</span>
          <b-form-checkbox-group
            name="hasEventType"
            class="scrollable-section search-panel-items search-filter-list"
            v-model="hasEventType"
          >
            <b-form-checkbox
              v-for="option in eventTypeOptions"
              :key="option.id"
              :value="option.id"
              class="col-md-12 noselect">
                {{ option.name }}
            </b-form-checkbox>
          </b-form-checkbox-group>
          <span class="sub-search-type-filter search-panel-items">Does Not Have Event Type</span>
          <b-form-checkbox-group
                name="doesNotHaveEventType"
                class="scrollable-section search-panel-items search-filter-list"
                v-model="doesNotHaveEventType"
                >
                <b-form-checkbox
                v-for="option in eventTypeOptions"
                :key="option.id"
                :value="option.id"
                class="col-md-12 noselect">
                  {{ option.name }}
                </b-form-checkbox>
          </b-form-checkbox-group>
          <span class="sub-search-type-filter search-panel-items">With Event Date After</span>
          <div v-if="hasEventType.length === 0 && doesNotHaveEventType.length === 0"
               class="search-panel-items">
            Select Event Types above to select a date.
          </div>
          <template v-else>
            <datepicker
               id="eventDateAfter"
               :class="'flex-grow-1'"
               format="MM/dd/yyyy"
               input-class="form-control bg-white"
               :clear-button="true"
               v-model="eventDateAfter"
               :bootstrap-styling="true"
               name="eventDateAfter"
               >
               <div slot="afterDateInput" class="input-group-append">
                 <span class="input-group-text">
                   <font-awesome-icon icon="calendar-alt" />
                 </span>
               </div>
            </datepicker>
          </template>
          <span class="sub-search-type-filter search-panel-items">With Event Date Before</span>
          <div v-if="hasEventType.length === 0 && doesNotHaveEventType.length === 0"
               class="search-panel-items">
            Select Event Types above to select a date.
          </div>
          <template v-else>
            <datepicker
               id="eventDateBefore"
               :class="'flex-grow-1'"
               format="MM/dd/yyyy"
               input-class="form-control bg-white"
               :clear-button="true"
               v-model="eventDateBefore"
               :bootstrap-styling="true"
               name="eventDateBefore"
               >
               <div slot="afterDateInput" class="input-group-append">
                 <span class="input-group-text">
                   <font-awesome-icon icon="calendar-alt" />
                 </span>
               </div>
            </datepicker>
          </template>
        </div>
      </b-collapse>
    </div>
  </div>
</template>
<script>

import moment from 'moment-timezone';
import Datepicker from 'vuejs-datepicker';
import { LookupModules } from '@/store/moduleConfig';

export default {
  name: 'EventTypeSearchFacet',
  components: {
    Datepicker,
  },
  data() {
    return {
    };
  },
  computed: {
    initialSearchCategoryStates() {
      return this.$store.state.Search.initialSearchCategoryStates;
    },
    eventTypeOptions() {
      if (this.$store.state.Search.searchEntityType === 'Instrument') {
        return this.$store.getters[`${LookupModules.INSTRUMENT_EVENT_TYPES.namespace}/getAllOptions`];
      }
      return this.$store.getters[`${LookupModules.SERVICE_EVENT_TYPES.namespace}/getAllOptions`];
    },
    eventTypeOptionsLoading() {
      if (this.$store.state.Search.searchEntityType === 'Instrument') {
        return this.$store.state[LookupModules.INSTRUMENT_EVENT_TYPES.namespace].loading;
      }
      return this.$store.state[LookupModules.SERVICE_EVENT_TYPES.namespace].loading;
    },
    hasEventType: {
      get() {
        return this.getOption('hasEventType');
      },
      set(value) {
        this.setFacet('hasEventType', value);
      },
    },
    doesNotHaveEventType: {
      get() {
        return this.getOption('doesNotHaveEventType');
      },
      set(value) {
        this.setFacet('doesNotHaveEventType', value);
      },
    },
    eventDateAfter: {
      get() {
        return this.getDateOption('eventDateAfter');
      },
      set(value) {
        this.setDateFacet('eventDateAfter', value);
      },
    },
    eventDateBefore: {
      get() {
        return this.getDateOption('eventDateBefore');
      },
      set(value) {
        this.setDateFacet('eventDateBefore', value);
      },
    },
  },
  mounted() {
    this.$store.dispatch(`${LookupModules.INSTRUMENT_EVENT_TYPES.namespace}/fetchOptions`,
      LookupModules.INSTRUMENT_EVENT_TYPES.url);
    this.$store.dispatch(`${LookupModules.SERVICE_EVENT_TYPES.namespace}/fetchOptions`,
      LookupModules.SERVICE_EVENT_TYPES.url);
  },
  methods: {
    getDateOption(fieldName) {
      return this.getOption(fieldName)[0];
    },
    getOption(fieldName) {
      return this.$store.state.Search.selectedSearchFacets[fieldName];
    },
    setDateFacet(fieldName, value) {
      this.setFacet(fieldName,
        [moment.tz(value, 'UTC').tz('America/New_York').format('MM/DD/YYYY')]);
    },
    setFacet(fieldName, value) {
      this.$store.dispatch(
        'Search/updateSearchFacet',
        {
          type: fieldName,
          values: value,
        },
      );
    },
  },
};
</script>
